var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrivacy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.68167 8.02317C6.36167 8.60983 5.5 9.92983 5.5 11.3782V19.9948C5.5 30.1698 12.54 39.6848 22 41.9948C31.46 39.6848 38.5 30.1698 38.5 19.9948V11.3782C38.5 9.92983 37.6383 8.60983 36.3183 8.02317L23.485 2.3215C22.5317 1.89983 21.45 1.89983 20.515 2.3215L7.68167 8.02317ZM22 12.6615C23.0083 12.6615 23.8333 13.4865 23.8333 14.4948C23.8333 15.5032 23.0083 16.3282 22 16.3282C20.9917 16.3282 20.1667 15.5032 20.1667 14.4948C20.1667 13.4865 20.9917 12.6615 22 12.6615ZM22 19.9948C23.0083 19.9948 23.8333 20.8198 23.8333 21.8282V29.1615C23.8333 30.1698 23.0083 30.9948 22 30.9948C20.9917 30.9948 20.1667 30.1698 20.1667 29.1615V21.8282C20.1667 20.8198 20.9917 19.9948 22 19.9948Z",
    fill: "#B71C1C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.6357ffc3161973cfb4def6e2171fbc65.svg";
export { ForwardRef as ReactComponent };